export enum DeviceType {
  // Умный поворот
  smartTurn = 1,
  // Умный светильник
  smartLight = 2,
  // Метеостанция
  meteo = 4,
  // КСОДД
  ksodd = 5,
  // КАО
  kao = 6,
  // Фотокамера
  photo = 7,
  // Видеокамера
  video = 8,
  // ДИТ
  dit = 9,
  // Светофорный обьект
  trafficLight = 11,
  // Освещение
  lightning = 14,
  // Освещение песпектива
  lightningPerspective = 15,
  // Предочаг ДТП
  dtpYellow = 16,
  // Очаг ДТП
  dtpRed = 17,
}

export const SmartDevicesIds = [
  DeviceType.smartTurn,
  DeviceType.smartLight,
  DeviceType.meteo,
]

export const SimpleDevicesIds = [
  DeviceType.kao,
  DeviceType.ksodd,
  DeviceType.trafficLight,
  DeviceType.lightning,
  DeviceType.lightningPerspective,
]
